import cn from 'classnames'
import qs from 'qs'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MiniAssetPreview from '../assetpreview/MiniAssetPreview'
import CheckIndicator from '../checkindicator/CheckIndicator'
import ErrorNote from '../common/util/ErrorNote'
import MainButton from '../common/util/input/MainButton'
import LoadingIndicator from '../loadingindicator'
import { Context, useSharedState } from '../waxplorer/Waxplorer'

const TradeItem = (props) => {
    const trade = props['trade']

    const {
        recipient,
        sender,
        recipient_assets,
        sender_assets,
        offerId,
        memo,
    } = trade
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    let values = qs.parse(
        window.location.search.substring(1, window.location.search.length),
    )

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : values['user']

    const { t } = useTranslation('common')

    const [error, setError] = useState(null)

    const [isLoading, setIsLoading] = useState(false)
    const [declined, setDeclined] = useState(false)
    const [accepted, setAccepted] = useState(false)
    const [canceled, setCanceled] = useState(false)

    const [, dispatch] = useContext(Context)

    const handleDecline = (tradeInfo) => {
        if (tradeInfo) {
            if (tradeInfo['error']) {
                setError(tradeInfo['error'])
                setIsLoading(false)
            }
            if (tradeInfo['confirmed']) setDeclined(true)
            else setIsLoading(false)
        }
        setIsLoading(false)
    }

    const handleAccept = (tradeInfo) => {
        if (tradeInfo) {
            if (tradeInfo['error']) {
                setError(tradeInfo['error'])
                setIsLoading(false)
            }
            if (tradeInfo['confirmed']) setAccepted(true)
            else setIsLoading(false)
        }
        setIsLoading(false)
    }

    const handleCancel = (tradeInfo) => {
        if (tradeInfo) {
            if (tradeInfo['error']) {
                setError(tradeInfo['error'])
                setIsLoading(false)
            }
            if (tradeInfo['confirmed']) setCanceled(true)
            else setIsLoading(false)
        }
        setIsLoading(false)
    }

    const decline = () => {
        setIsLoading(true)
        dispatch({ type: 'SET_OFFER_ID', payload: offerId })
        dispatch({ type: 'SET_TRADE_OPTION', payload: 'decline' })
        dispatch({
            type: 'SET_CALLBACK',
            payload: (tradeInfo) => handleDecline(tradeInfo),
        })
        dispatch({ type: 'SET_ACTION', payload: 'handle_trade' })
    }

    const accept = () => {
        setIsLoading(true)
        dispatch({ type: 'SET_OFFER_ID', payload: offerId })
        dispatch({ type: 'SET_TRADE_OPTION', payload: 'accept' })
        dispatch({
            type: 'SET_CALLBACK',
            payload: (tradeInfo) => handleAccept(tradeInfo),
        })
        dispatch({ type: 'SET_ACTION', payload: 'handle_trade' })
    }

    const cancel = () => {
        setIsLoading(true)
        dispatch({ type: 'SET_OFFER_ID', payload: offerId })
        dispatch({ type: 'SET_TRADE_OPTION', payload: 'cancel' })
        dispatch({
            type: 'SET_CALLBACK',
            payload: (tradeInfo) => handleCancel(tradeInfo),
        })
        dispatch({ type: 'SET_ACTION', payload: 'handle_trade' })
    }

    const dismissError = () => {
        setError(null)
    }

    const tradeButtonsClass = cn(
        'relative w-80 flex flex-wrap justify-evenly mx-auto',
    )

    const tradeItemsBoxCn = cn(
        'flex w-full h-64 md:h-80 border border-primary overflow-x-auto mb-5 px-2 rounded-xl bg-secondaryt',
    )

    return declined || canceled ? (
        ''
    ) : (
        <div className={cn('w-full')}>
            <div className={cn('grid grid-cols-1 md:grid-cols-2 gap-x-5')}>
                <div>
                    <div className={cn('pt-2 pb-5 font-bold w-full')}>
                        {sender}
                    </div>
                    <div className={tradeItemsBoxCn}>
                        <div
                            className={
                                'flex flex-wrap overflow-y-auto InsideScroll h-full'
                            }
                        >
                            {sender_assets.map((asset) => (
                                <div className={cn('m-4')}>
                                    <MiniAssetPreview asset={asset} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div>
                    <div className={cn('pt-2 pb-5 font-bold w-full')}>
                        {recipient}
                    </div>
                    <div className={tradeItemsBoxCn}>
                        <div
                            className={'flex flex-wrap overflow-y-auto h-full'}
                        >
                            {recipient_assets.map((asset) => (
                                <div className={cn('m-4')}>
                                    <MiniAssetPreview asset={asset} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className={'pt-0 pb-40 md:pb-0 md:h-40 md:pt-0'}>
                {error ? (
                    <div className={tradeButtonsClass}>
                        <ErrorNote onClick={dismissError} error={error} />
                    </div>
                ) : isLoading ? (
                    <div className={tradeButtonsClass}>
                        <LoadingIndicator />
                    </div>
                ) : userName === recipient ? (
                    <div className={tradeButtonsClass}>
                        <div className="w-full flex justify-center text-sm mb-4">{`${t(
                            'trade.memo',
                        )}: ${memo}`}</div>
                        <div className={'w-full flex justify-center'}>
                            {accepted ? (
                                ''
                            ) : (
                                <MainButton
                                    className="max-w-40 w-40 mr-2"
                                    onClick={decline}
                                >
                                    {t('trade.decline')}
                                </MainButton>
                            )}
                            {accepted ? (
                                <CheckIndicator />
                            ) : (
                                <MainButton
                                    className="max-w-40 w-40 ml-2"
                                    onClick={accept}
                                >
                                    {t('trade.accept')}
                                </MainButton>
                            )}
                        </div>
                    </div>
                ) : userName === sender ? (
                    <div
                        className={cn(
                            'relative w-full top-4 min-w-min font-bold dark:text-white text-black block m-auto',
                        )}
                    >
                        <div className="w-full flex justify-center text-sm mb-4">{`${t(
                            'trade.memo',
                        )}: ${memo ? memo : '-'}`}</div>
                        <div className={'w-full flex justify-center'}>
                            <MainButton
                                className="max-w-40 w-40 mx-auto"
                                onClick={cancel}
                            >
                                {t('asset.cancel')}
                            </MainButton>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        </div>
    )
}

export default TradeItem
